<template>
  <a-drawer width="55%" :label-col="4" :wrapper-col="14" :visible="open" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form"  :rules="rules">
      <a-form-model-item :label="$t('投诉用户编号')"  class="hide">
        <a-input v-model="form.targetId" readOnly   />
      </a-form-model-item>
      <a-form-model-item :label="$t('投诉用户名称')"  class="hide">
        <a-input v-model="form.targetName" readOnly   />
      </a-form-model-item>
      <a-form-model-item :label="$t('投诉原因')" prop="location"  class="hide">
        <a-select style="width: 100%" v-model="form.reasonId" allowClear disabled="true">
          <a-select-option v-for="(item, index) in this.reasonList" :value="item.id"
                           :key="index">
            {{ item.title }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item :label="$t('反馈内容')" prop="content"  class="hide">
        <a-textarea v-model="form.content"  :auto-size="{ minRows: 3, maxRows: 5 }"  readOnly />
      </a-form-model-item>
      <a-form-model-item :label="$t('反馈图片')"  class="hide" prop="imgUrlList" >
        <oss-upload-multi :is-array-data="true" :disabled="true" :max-count="5" v-model="form.imgUrlList" prefix="goods" type="img"/>
      </a-form-model-item>
      <a-form-model-item :label="$t('是否审核通过')" prop="type" >
        <a-select style="width: 100%" v-model="form.isPass">
          <a-select-option v-for="(item, index) in this.customDict.TFEnum" :value="item.type" :key="index">
            {{ item.name }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item :label="$t('处理结果')" prop="processResult" >
        <a-input v-model="form.processResult" placeholder="请输入处理结果" />
        <span>审核通过后,该用户账号将被停用</span>
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{$t('保存')}}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{$t('取消')}}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getCommunityReport,auditCommunityReport } from '@/api/community/report'
import {mapGetters} from 'vuex'
import CustomDictTag from "@/components/DictCustomTag";
import OssUploadMulti from "@/components/OssUploadMulti/index.vue";

export default {
  name: 'CreateForm',
  props: {
    reasonList: {
      type: Array,
      require: true
    }
  },
  components: {
    OssUploadMulti,
    CustomDictTag,
  },
  data () {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      submitLoading: false,
      formTitle: '',
      loading: '',
      imgUrlList: [],
      // 表单参数
      form: {
        id: null,
        targetName: null,
        reasonId: null,
        imgUrlList: [],
        remark: null,
        localeFieldMap: {},
        userId: null,
        type: null,
        processStatus: 0,
        processResult: null,
        contact: null,
        evaluation: null,

        createTime: null,

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        userId: [
          { required: true, message: '用户id，外键{user.id}不能为空', trigger: 'blur' }
        ],
        type: [
          { required: true, message: '反馈类型：1-意见建议、2-故障报告、3-投诉不能为空', trigger: 'change' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
      this.reset()
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        targetName: null,
        reasonId: null,
        imgUrlList: [],
        remark: null,
        localeFieldMap: {},
        userId: null,
        type: null,
        processStatus: 0,
        processResult: null,
        contact: null,
        evaluation: null,

        createTime: null,
      }

    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleUpdate (row) {
      this.reset()
      this.formType = 2
      const id = row.id
      getCommunityReport({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = this.$t('修改')
      })
    },
    // oss 上传开始
    async handlePreview(file) {
      if (!file.url && !file.preview) {
        file.preview = await this.getBase64(file.originFileObj)
      }
      this.previewImage = file.url || file.preview
      this.previewVisible = true
    },
    getUidRandom() {
      return Math.round(Math.random() * 80 + 20)
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            auditCommunityReport(this.form).then(response => {
              this.$message.success(
                '审核成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
<style scoped lang="less">
.hide {
  /deep/ .ant-input {
    border: 0 !important;
  }
}
</style>
